import "./home-links";
import './banner';
import './conseil-municipal';
import './filters';
import './beaver-accordeon';